import React, { Component } from "react";
import { Switch } from "react-router-dom";

import PrivateRoute from "../../utils/PrivateRoute";

import TradeSupportingDocuments from "./containers/SupportingDocuments";
import TradeSupportingDocumentForm from "./containers/Form";

class TradeSupportingDocumentRoutes extends Component {
  render() {
    return (
      <Switch>
        <PrivateRoute
          exact
          path="/(purchase_orders|invoices)/:id/supporting_documents/new"
          component={TradeSupportingDocumentForm}
        />
        <PrivateRoute
          exact
          path="/(purchase_orders|invoices)/:id/supporting_documents"
          component={TradeSupportingDocuments}
        />
      </Switch>
    );
  }
}

export default TradeSupportingDocumentRoutes;



// WEBPACK FOOTER //
// ./src/features/supporting_documents/routes.js